import { MembershipPlanModel } from './MembershipPlanModel';

export class PlanMemberModel {
    constructor(planMemberData) {
        const plan = this.getMembershipPlan(planMemberData);

        this._planMember = {
            id: planMemberData.id,
            credits: planMemberData.credits,
            expiresAt: planMemberData.expires_at,
            createdAt: planMemberData.created_at,
            plan,
        };
    }

    get planMember() {
        return this._planMember;
    }

    getMembershipPlan(planMemberData) {
        let plan;

        if (planMemberData.plan) {
            const membershipPlanModel = new MembershipPlanModel(planMemberData.plan.data);
            plan = { ...membershipPlanModel._membershipPlan };
        }

        return plan;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/PlanMemberModel.js